import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-e88d1846"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center fixed inset-y-0 right-0 lg:overflow-x-hidden lg:overflow-y-hidden z-50 w-full overflow-scroll py-5 lg:py-0"
}
const _hoisted_2 = { class: "flex relative w-full lg:w-1/3 lg:h-auto p-3 lg:p-0" }
const _hoisted_3 = { class: "flex flex-col bg-white w-full h-auto rounded-2xl shadow p-8" }
const _hoisted_4 = { class: "flex flex-row justify-between mb-8" }
const _hoisted_5 = {
  key: 0,
  class: "font-semibold text-lg"
}
const _hoisted_6 = {
  key: 1,
  class: "font-semibold text-lg"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "w-full mb-4" }
const _hoisted_10 = { class: "w-full mb-4" }
const _hoisted_11 = { class: "w-full mb-4" }
const _hoisted_12 = { class: "w-full mb-4" }
const _hoisted_13 = { class: "w-full mb-4" }
const _hoisted_14 = { class: "w-full mb-4" }
const _hoisted_15 = {
  key: 0,
  class: "w-full mb-4"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-8" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-600 text-gray-400" }, "Choose product(s)")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-0.5 bg-gray-200 my-2 mb-4" }, null, -1))
const _hoisted_18 = { class: "w-full mb-8" }
const _hoisted_19 = { class: "grid grid-cols-2 gap-2 content-start mt-6 justify-center items-center check-content" }
const _hoisted_20 = { class: "flex flex-row justify-between items-center" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "relative flex flex-row items-center justify-center ml-4 mr-4" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 2,
  class: "ml-4"
}
const _hoisted_25 = {
  key: 1,
  class: "bg-black opacity-50 fixed inset-y-0 right-0 z-40 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_CheckBoxGroup = _resolveComponent("CheckBoxGroup")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (!_ctx.isEditing)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Add new client "))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, " Edit client ")),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }, _hoisted_8)
              ]),
              _createElementVNode("form", null, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_TextField, {
                    name: "first_name",
                    label: "First name",
                    typeInput: "text",
                    disabled: _ctx.loading,
                    isError: _ctx.fieldErrors.first_name
                  }, null, 8, ["disabled", "isError"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_TextField, {
                    name: "last_name",
                    label: "Last name",
                    typeInput: "text",
                    disabled: _ctx.loading,
                    isError: _ctx.fieldErrors.last_name
                  }, null, 8, ["disabled", "isError"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_TextField, {
                    name: "email",
                    label: "Email",
                    typeInput: "email",
                    disabled: _ctx.isEditing || _ctx.loading,
                    isError: _ctx.fieldErrors.email
                  }, null, 8, ["disabled", "isError"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_TextField, {
                    name: "company_name",
                    label: "Company name",
                    typeInput: "text",
                    disabled: _ctx.loading,
                    modelValue: _ctx.company_name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.company_name) = $event)),
                    isError: _ctx.fieldErrors.company_name
                  }, null, 8, ["disabled", "modelValue", "isError"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_DropDown, {
                    modelValue: _ctx.company_industry_id,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.company_industry_id) = $event)),
                    label: "Select company industry",
                    options: _ctx.companyIndustries,
                    typeInput: "text",
                    name: "company_industry_id",
                    isError: _ctx.fieldErrors.company_industry_id
                  }, null, 8, ["modelValue", "options", "isError"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_DropDown, {
                    modelValue: _ctx.country_1,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.country_1) = $event)),
                    label: "Select a country",
                    options: _ctx.countriesDefault,
                    typeInput: "text",
                    disabled: _ctx.loading,
                    name: "country_1",
                    isError: _ctx.fieldErrors.country_1
                  }, null, 8, ["modelValue", "options", "disabled", "isError"])
                ]),
                (_ctx.country_1 === 'other')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_DropDown, {
                        modelValue: _ctx.auxCountry,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.auxCountry) = $event)),
                        label: "Select a country",
                        options: _ctx.countries,
                        typeInput: "text",
                        disabled: _ctx.loading,
                        name: "auxCountry",
                        isError: _ctx.fieldErrors.auxCountry
                      }, null, 8, ["modelValue", "options", "disabled", "isError"])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_16,
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.platforms, (item, index) => {
                      return (_openBlock(), _createBlock(_component_CheckBoxGroup, {
                        key: `item-checkbox-${index + 1}`,
                        fieldId: item.id,
                        names: _ctx.checkValues,
                        "onUpdate:names": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.checkValues) = $event)),
                        label: item.name,
                        value: item.id,
                        disabled: item.available
                      }, null, 8, ["fieldId", "names", "label", "value", "disabled"]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                  class: "rounded-full border-2 border-primary text-primary py-4 px-6"
                }, " Cancel "),
                _createElementVNode("button", {
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
                  disabled: !_ctx.meta.valid || _ctx.checkValues.length <= 0,
                  class: _normalizeClass(["disabled:opacity-50 disabled:cursor-not-allowed", {
                'btn-filled-lg': !_ctx.loading,
                'btn-filled-lg-loading': _ctx.loading,
              }])
                }, [
                  _createElementVNode("div", _hoisted_22, [
                    (_ctx.loading)
                      ? (_openBlock(), _createBlock(_component_Spinner, {
                          key: 0,
                          color: "white",
                          height: "6",
                          width: "6",
                          border: "2"
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.isEditing ? "Edit" : "Create"), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_24, "Loading..."))
                  ])
                ], 10, _hoisted_21)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25))
      : _createCommentVNode("", true)
  ]))
}